"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/client";
import { queryKeys } from "@/lib/api/query";

export function useTeamPermissions() {
  const team = useQuery({ queryKey: queryKeys.team, queryFn: api.teams.get });
  const role = team.data?.myRole ?? "VIEWER";
  return {
    role,
    canEdit: role === "OWNER" || role === "ADMIN" || role === "EDITOR",
    canManage: role === "OWNER" || role === "ADMIN",
    canApprove: role === "OWNER" || role === "ADMIN",
    isOwner: role === "OWNER",
  };
}
